import React from 'react'

import { func, number } from 'prop-types'

const DEFAULT_LABEL = (start, end, total) => `Showing ${start}-${end} of ${total}`

function NumberOfItems({ totalCount, perPage, currentPage, label = DEFAULT_LABEL }) {
  const startItem = (currentPage - 1) * perPage + 1
  const endItem = Math.min(currentPage * perPage, totalCount)

  return (
    <div className="shared-pagination__number-of-items">
      <span className="shared-pagination__count">
        {label(startItem, endItem, totalCount)}
      </span>
    </div>
  )
}

NumberOfItems.propTypes = {
  totalCount: number.isRequired,
  perPage: number.isRequired,
  currentPage: number.isRequired,
  label: func,
}

export default NumberOfItems
